/**
 * Authentication Forms Handler
 * Handles AJAX submission for login, registration, and comment forms
 * 
 * @since 3.7.0
 */

(function($) {
    'use strict';

    // Wait for DOM to be ready
    $(document).ready(function() {
        initAuthForms();
    });

    /**
     * Initialize authentication forms
     */
    function initAuthForms() {
        // Intercept submit button clicks BEFORE default handler with highest priority
        $(document).on('click', '.simple_form_container .submit-button', function(e) {
            const $button = $(this);
            const $container = $button.closest('.simple_form_container');
            
            // Check if this form is configured as an auth form
            const formId = parseInt($container.data('form-id'));
            const formType = getAuthFormType(formId);
            
            // console.log('Form ID:', formId, 'Auth Form Type:', formType);
            
            if (formType === 'login' || formType === 'registration') {
                // Auth form - prevent ALL default behaviors
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                handleAuthFormSubmit($container, formType);
                return false;
            } else if (formType === 'comment') {
                // Comment form - prevent ALL default behaviors
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                handleCommentFormSubmit($container);
                return false;
            }
            // If regular form, let default handler run (leads submission)
        });
        
        // Also intercept form submit events for auth forms
        $(document).on('submit', '.simple_form_container form', function(e) {
            const $form = $(this);
            const $container = $form.closest('.simple_form_container');
            const formId = parseInt($container.data('form-id'));
            const formType = getAuthFormType(formId);
            
            if (formType === 'login' || formType === 'registration' || formType === 'comment') {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            }
        });
        
        // Handle WordPress comment form submissions
        $(document).on('submit', 'form.simpleform-comment-form', function(e) {
            e.preventDefault();
            const $form = $(this);
            const $container = $form.find('.simple_form_container').first();
            
            if ($container.length > 0) {
                handleCommentFormSubmit($container);
            }
        });
    }

    /**
     * Get auth form type based on form ID from settings
     */
    function getAuthFormType(formId) {
        if (!formId) return 'regular';
        
        // Check if front_end_data and auth_form_ids are available
        if (typeof front_end_data === 'undefined' || typeof front_end_data.auth_form_ids === 'undefined') {
            return 'regular';
        }
        
        const authFormIds = front_end_data.auth_form_ids;
        const id = parseInt(formId, 10);
        
        // Check if this form ID matches any configured auth form
        if (id && (id === parseInt(authFormIds.wp_login, 10) || id === parseInt(authFormIds.wc_login, 10))) {
            return 'login';
        } else if (id && (id === parseInt(authFormIds.wp_registration, 10) || id === parseInt(authFormIds.wc_registration, 10))) {
            return 'registration';
        } else if (id && id === parseInt(authFormIds.comment, 10)) {
            return 'comment';
        }
        
        return 'regular';
    }

    // Expose helpers globally so frontend.js can invoke directly
    window.sfGetAuthFormType = getAuthFormType;
    window.sfHandleAuthSubmit = function(containerEl, formId) {
        const $container = $(containerEl);
        const fid = formId || parseInt($container.data('form-id'), 10);
        const formType = getAuthFormType(fid);
        if (formType === 'login' || formType === 'registration') {
            handleAuthFormSubmit($container, formType);
        } else if (formType === 'comment') {
            handleCommentFormSubmit($container);
        }
    };

    /**
     * Handle auth form (login/registration) submission
     */
    function handleAuthFormSubmit($container, formType) {
        // Prevent duplicate submissions
        if ($container.hasClass('submitting')) {
            return;
        }

        // Check if front_end_data is available
        if (typeof front_end_data === 'undefined') {
            console.error('front_end_data is not defined!');
            showMessage($container, 'error', 'Configuration error. Please refresh the page.');
            return;
        }
        
        // Collect form data
        const formData = new FormData();
        const action = formType === 'registration' ? 'simpleform_wp_register' : 'simpleform_wp_login';
        
        // Scan and inspect all form inputs
        const inputs = [];
        $container.find('input, select, textarea').each(function() {
            const $field = $(this);
            const name = $field.attr('name') || '';
            const type = ($field.attr('type') || $field.prop('tagName') || 'text').toLowerCase();
            const val = $field.val() || '';
            const id = ($field.attr('id') || '').toLowerCase();
            const placeholder = ($field.attr('placeholder') || '').toLowerCase();
            const subtype = ($field.attr('data-subtype') || '').toLowerCase();
            
            // Associated label text if any
            const fieldId = $field.attr('id');
            const $label = fieldId ? $container.find('label[for="' + fieldId + '"]') : null;
            const labelText = ($label && $label.length ? $label.text() : $field.closest('.text-fields, .fields, .field-wrapper').find('label').text() || '').toLowerCase();
            
            inputs.push({
                $el: $field,
                name: name,
                type: type,
                subtype: subtype,
                val: val,
                id: id,
                placeholder: placeholder,
                label: labelText,
                checked: $field.is(':checked')
            });

            // Append raw name as well (preserves custom fields for leads and user meta)
            if (name) {
                if (type === 'checkbox') {
                    formData.append(name, $field.is(':checked') ? 'on' : 'off');
                } else {
                    formData.append(name, val);
                }
            }
        });

        // SMART FIELD NORMALIZATION: Map dynamic builder inputs to canonical auth fields
        // 1. Password field(s)
        const passwordFields = inputs.filter(inp => 
            inp.type === 'password' || 
            inp.subtype === 'password' || 
            inp.name.toLowerCase().includes('password') || 
            inp.id.includes('password')
        );

        let mainPassword = '';
        let confirmPassword = '';

        if (passwordFields.length > 0) {
            mainPassword = passwordFields[0].val;
            if (passwordFields.length > 1) {
                confirmPassword = passwordFields[1].val;
            }
        }

        // Check for explicit confirm password input
        const explicitConfirm = inputs.find(inp => 
            inp.name.toLowerCase().includes('confirm') || 
            inp.id.includes('confirm') || 
            inp.label.includes('confirm')
        );
        if (explicitConfirm) {
            confirmPassword = explicitConfirm.val;
        }

        // 2. Email field
        const emailField = inputs.find(inp => 
            inp.type === 'email' || 
            inp.subtype === 'email' || 
            inp.name.toLowerCase().includes('email') || 
            inp.id.includes('email') || 
            inp.label.includes('email') || 
            inp.placeholder.includes('email')
        );
        const emailVal = emailField ? emailField.val : '';

        // 3. Username field
        const usernameField = inputs.find(inp => 
            inp.id === 'username' || 
            inp.name.toLowerCase().includes('user_login') || 
            inp.name.toLowerCase().includes('username') || 
            inp.label.includes('username') || 
            inp.label.includes('user') ||
            (inp.type === 'text' && !passwordFields.includes(inp) && inp !== emailField && inp !== explicitConfirm)
        );
        let usernameVal = usernameField ? usernameField.val : '';

        // In WordPress login, a user can enter either their username OR email address
        if (formType === 'login') {
            if (!usernameVal && emailVal) {
                usernameVal = emailVal;
            } else if (!usernameVal) {
                const firstText = inputs.find(inp => inp.type === 'text' && !passwordFields.includes(inp));
                if (firstText) usernameVal = firstText.val;
            }
        } else if (formType === 'registration') {
            // For registration, if no separate username field exists, fallback to email prefix
            if (!usernameVal && emailVal) {
                usernameVal = emailVal.split('@')[0];
            }
        }

        // Set canonical auth parameters
        if (usernameVal) formData.set('username', usernameVal);
        if (mainPassword) formData.set('password', mainPassword);
        if (emailVal) formData.set('email', emailVal);
        if (confirmPassword) formData.set('confirm_password', confirmPassword);

        // Remember Me checkbox
        const rememberField = inputs.find(inp => 
            inp.type === 'checkbox' && (
                inp.name.toLowerCase().includes('remember') || 
                inp.id.includes('remember') || 
                inp.label.includes('remember')
            )
        );
        if (rememberField) {
            formData.set('remember', rememberField.checked ? 'on' : 'off');
        }

        // Terms acceptance
        const termsField = inputs.find(inp => 
            inp.type === 'checkbox' && (
                inp.name.toLowerCase().includes('terms') || 
                inp.name.toLowerCase().includes('condition') || 
                inp.name.toLowerCase().includes('agree') ||
                inp.id.includes('terms') || 
                inp.label.includes('terms') || 
                inp.label.includes('condition') || 
                inp.label.includes('agree')
            )
        );
        if (termsField) {
            formData.set('terms', termsField.checked ? 'on' : 'off');
        }

        // Check terms acceptance for registration if terms checkbox was present in the form
        if (formType === 'registration' && termsField && !termsField.checked) {
            showMessage($container, 'error', 'Please accept the terms and conditions to continue.');
            return;
        }
        
        // Get form ID
        const formId = $container.data('form-id');
        
        // Add action and form ID
        formData.append('action', action);
        formData.append('form_id', formId);
        // SECURITY: use the dedicated registration nonce when available
        const nonceToUse = (formType === 'registration' && typeof front_end_data.reg_nonce !== 'undefined')
            ? front_end_data.reg_nonce
            : front_end_data.nonce;
        formData.append('nonce', nonceToUse);
        
        // Show loading state
        const $submitBtn = $container.find('.submit-button');
        const originalText = $submitBtn.text();
        $submitBtn.prop('disabled', true).text('Processing...');
        $container.addClass('submitting');
        
        // Submit via AJAX
        $.ajax({
            url: front_end_data.admin_ajax,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                $container.removeClass('submitting');
                $submitBtn.prop('disabled', false).text(originalText);
                
                if (response.success) {
                    showMessage($container, 'success', response.data.message || (formType === 'login' ? 'Login successful!' : 'Registration successful!'));
                    
                    // Clear form fields
                    $container.find('input[type="text"], input[type="password"], input[type="email"]').val('');
                    $container.find('input[type="checkbox"]').prop('checked', false);
                    
                    // Redirect if URL provided
                    if (response.data.redirect_url) {
                        setTimeout(function() {
                            window.location.href = response.data.redirect_url;
                        }, 1200);
                    } else {
                        setTimeout(function() {
                            window.location.reload();
                        }, 1200);
                    }
                } else {
                    showMessage($container, 'error', (response.data && response.data.message) ? response.data.message : 'An error occurred. Please try again.');
                }
            },
            error: function(xhr, status, error) {
                $container.removeClass('submitting');
                $submitBtn.prop('disabled', false).text(originalText);
                showMessage($container, 'error', 'An error occurred. Please try again.');
                console.error('Auth AJAX Error:', error);
            }
        });
    }

    /**
     * Handle comment form submission
     */
    function handleCommentFormSubmit($container) {
        if ($container.hasClass('submitting')) {
            return;
        }

        // Collect form data
        const formData = new FormData();
        const inputs = [];
        
        // Get all form inputs
        $container.find('input, select, textarea').each(function() {
            const $field = $(this);
            const name = $field.attr('name') || '';
            const type = ($field.attr('type') || $field.prop('tagName') || 'text').toLowerCase();
            const val = $field.val() || '';
            const id = ($field.attr('id') || '').toLowerCase();
            const labelText = ($field.closest('.text-fields, .fields, .field-wrapper').find('label').text() || '').toLowerCase();

            inputs.push({
                $el: $field,
                name: name,
                type: type,
                val: val,
                id: id,
                label: labelText
            });

            if (name) {
                formData.append(name, val);
            }
        });

        // Normalize comment fields: comment, author, email, url
        const commentField = inputs.find(inp => 
            inp.type === 'textarea' || 
            inp.name.toLowerCase().includes('comment') || 
            inp.name.toLowerCase().includes('message') || 
            inp.label.includes('comment') || 
            inp.label.includes('message')
        );
        if (commentField && !formData.has('comment')) {
            formData.set('comment', commentField.val);
        }

        const authorField = inputs.find(inp => 
            (inp.type === 'text' && inp !== commentField) && (
                inp.name.toLowerCase().includes('author') || 
                inp.name.toLowerCase().includes('name') || 
                inp.label.includes('author') || 
                inp.label.includes('name')
            )
        );
        if (authorField && !formData.has('author')) {
            formData.set('author', authorField.val);
        }

        const commentEmailField = inputs.find(inp => 
            inp.type === 'email' || 
            inp.name.toLowerCase().includes('email') || 
            inp.label.includes('email')
        );
        if (commentEmailField && !formData.has('email')) {
            formData.set('email', commentEmailField.val);
        }

        const urlField = inputs.find(inp => 
            inp.type === 'url' || 
            inp.name.toLowerCase().includes('website') || 
            inp.name.toLowerCase().includes('url')
        );
        if (urlField && !formData.has('url')) {
            formData.set('url', urlField.val);
        }
        
        // Get post ID - try multiple methods
        let postId = $container.find('input[name="comment_post_ID"]').val();
        
        if (!postId) {
            postId = $container.find('input.comment-post-id').val();
        }
        
        if (!postId) {
            postId = $container.closest('form').find('input[name="comment_post_ID"]').val();
        }
        
        if (!postId) {
            const $article = $('article').first();
            if ($article.length) {
                const articleId = $article.attr('id');
                if (articleId && articleId.indexOf('post-') === 0) {
                    postId = articleId.replace('post-', '');
                }
            }
        }
        
        if (!postId) {
            const bodyClasses = $('body').attr('class') || '';
            const match = bodyClasses.match(/postid-(\d+)/);
            if (match && match[1]) {
                postId = match[1];
            }
        }
        
        if (!postId) {
            const urlMatch = window.location.href.match(/[\?&]p=(\d+)/);
            if (urlMatch && urlMatch[1]) {
                postId = urlMatch[1];
            }
        }
        
        // console.log('Comment form - Post ID:', postId);
        
        if (!postId) {
            showMessage($container, 'error', 'Invalid post ID. Please refresh the page and try again.');
            return;
        }
        
        // Add action and post ID
        formData.append('action', 'simpleform_submit_comment');
        formData.append('comment_post_ID', postId);
        formData.append('nonce', front_end_data.nonce);
        
        // Show loading state
        const $submitBtn = $container.find('.submit-button');
        const originalText = $submitBtn.text();
        $submitBtn.prop('disabled', true).text('Submitting...');
        $container.addClass('submitting');
        
        // Submit via AJAX
        $.ajax({
            url: front_end_data.admin_ajax,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                $container.removeClass('submitting');
                $submitBtn.prop('disabled', false).text(originalText);
                
                if (response.success) {
                    // Show success message
                    showMessage($container, 'success', response.data.message || 'Comment submitted successfully!');
                    
                    // Clear form fields
                    $container.find('input[type="text"], input[type="email"], input[type="url"], textarea').val('');
                    
                    // Reload page after 2 seconds to show new comment
                    setTimeout(function() {
                        window.location.reload();
                    }, 2000);
                } else {
                    // Show error message
                    showMessage($container, 'error', response.data.message || 'Failed to submit comment. Please try again.');
                }
            },
            error: function(xhr, status, error) {
                $container.removeClass('submitting');
                $submitBtn.prop('disabled', false).text(originalText);
                showMessage($container, 'error', 'An error occurred. Please try again.');
                console.error('AJAX Error:', error);
            }
        });
    }

    /**
     * Show message to user
     */
    function showMessage($container, type, message) {
        // Remove existing messages
        $container.find('.simpleform-message').remove();
        
        // Create message element
        const $message = $('<div class="simpleform-message ' + type + '">' + message + '</div>');
        
        // Insert message at top of container
        $container.prepend($message);
        
        // Auto-hide after 5 seconds
        setTimeout(function() {
            $message.fadeOut(function() {
                $(this).remove();
            });
        }, 5000);
    }

})(jQuery);
